import { StyleSheet } from 'react-native';

const backgroundColor = '#ffffff';
const borderColor = '#ffffff';
const lightBackgroundColor = '#ffffff';
const darkBackgroundColor = '#ffffff';
const placeHolderColor = '#333333';

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: backgroundColor,
    padding: 0,
    margin: 0,
    alignSelf: 'center',
  },
  listContainer: {
    padding: 0,
    margin: 0,
    flex: 1,
  },
  searchBar: {
    fontSize: 14,
    color: placeHolderColor,
    padding: 0,
    margin: 0,
  },
  searchBarInput: {
    borderColor: borderColor,
  },
  resultList: {
    backgroundColor: backgroundColor,
    padding: 0,
    margin: 0,
    flexGrow: 0,
  },
  inputContainer: {
    backgroundColor: lightBackgroundColor,
    borderWidth: 1,
    borderColor: placeHolderColor,
    borderRadius: 6,
    borderBottomWidth: 1,
    marginTop: 0,
  },
  container: {
    padding: 0,
    paddingRight: 10,
    paddingLeft: 10,
    margin: 0,
    borderBottomWidth: 0,
    borderTopWidth: 0,
    backgroundColor: darkBackgroundColor,
    borderColor: borderColor,
    borderRadius: 0,
    marginTop: 0,
  },
  headerLeftItem: {
    alignSelf: 'center',
  },
  listItem: {
    marginTop: 0,
  },
  listItemDivider: {
    marginTop: 0,
    backgroundColor: backgroundColor,
  },
  searchHeaderContainer: {
    backgroundColor: darkBackgroundColor,
    flex: 1,
    flexDirection: 'row',
  },
  headerRightItem: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingBottom: 13,
    marginLeft: -3,
  },
  zonetailLogo: {
    width: 25,
    height: 25,
  },
  imageDown: {
    opacity: 0.3,
  },
});

export default styles;
